<template>
  <form @submit="onSubmit" data-cy="unit-search-form" @keydown.enter="$event.preventDefault()">
    <FlyIn
      v-if="!this.$settings('onlyFilter')"
      :hidden="isFlyInHidden"
      @getAmountActiveFitlers="setAmountActiveFilters"
    />
    <div class="o-layout o-layout--gutter-tiny o-layout--gutter-base@from-lap">
      <div
        class="o-layout__cell o-layout__cell--fill@from-desk u-margin-bottom-small"
      >
        <SearchQuery>
          <RadiusFilter />
        </SearchQuery>

        <SavedSearch v-if="this.$settings('onlyFilter')" />
      </div>
      <div
        v-if="this.$settings('onlyFilter')"
        class="o-layout__cell o-layout__cell--fit@from-lap u-margin-bottom-small"
      >
        <MyButton
          modifier="c-button--full-width  c-button--reversed  c-button--full-width  c-button--rounded"
          :is-reversed="true"
          :label="$label('search')"
          :disabled="submitIsDisabled"
          :click-callback="onClickSubmit"
          icon="magnifier"
          data-cy="unit-search-submit-button"
        />
      </div>
    </div>

    <div
      v-if="!this.$settings('onlyFilter')"
      class="o-layout o-layout--gutter-small"
    >
      <div class="o-layout__cell o-layout__cell--fit u-margin-bottom-small">
        <MyButton
          :label="`${$label('filters')} ${getAmountActiveFilters}`"
          modifier="c-button--small"
          icon="nav-toggle"
          isReversed
          :click-callback="triggerFlyIn"
        />
      </div>

      <div
        v-for="anchorLink in this.anchorLinks"
        :key="anchorLink.anchor"
        class="o-layout__cell o-layout__cell--fit u-margin-bottom-small"
      >
        <MyButton
          elementType="a"
          :href="`#${anchorLink.anchor}`"
          :label="anchorLink.label"
          :click-callback="triggerFlyIn"
          modifier="c-button--small c-button--tertiary"
        />
      </div>

      <div class="o-layout__cell o-layout__cell--fit u-margin-bottom-small">
        <MyButton
          modifier="c-button--small c-button--hyperlink"
          :label="$label('clearfilter')"
          :click-callback="removeActiveFilters"
        />
      </div>
    </div>
  </form>
</template>

<script>
import MyButton from '@/components/Utilities/Button.vue'
import FlyIn from '@/components/Filter/FlyIn.vue'
import RadiusFilter from '@/components/Filter/RadiusFilter.vue'
import SavedSearch from '@/components/Filter/SavedSearch.vue'
import SearchQuery from '@/components/Filter/SearchQuery.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'filterbox',
  components: { MyButton, FlyIn, RadiusFilter, SavedSearch, SearchQuery },

  data() {
    if (!this.$settings('onlyFilter')) {
      return {
        anchorLinks: global.vesteda.settings.filters.filter((f) => f.anchor),
        activeFilters: 0,
      }
    }
    else return {} // return empty object when no filters are present
  },
  computed: {
    ...mapGetters(['submitIsDisabled']),
    isFlyInHidden() {
      return this.$store.state.flyInVisible == false
    },
    getAmountActiveFilters() {
      return this.activeFilters !== 0 ? `(${this.activeFilters})` : ``
    },
  },
  methods: {
    onSubmit: function (e) {
      e.preventDefault()
    },
    onClickSubmit() {
      // Store for GA4
      localStorage.setItem('last_interacted', 'Regular')
      this.$store.dispatch('submitForm')
    },
    triggerFlyIn() {
      this.$store.dispatch('toggleFlyIn')
    },
    removeActiveFilters() {
      this.$store.dispatch('clearFilters')
    },
    setAmountActiveFilters(value) {
      this.activeFilters = value || 0
    },
  },
}
</script>
